export default {"src":"/_next/static/image/public/images/RxNumberImage.219b58ffb8c942d61d858615146dd25b.svg","height":220,"width":381};